module.exports = __webpack_public_path__ + "img/Georgia.bc25354f.svg";